export default __webpack_public_path__ + "static/media/imagotipo-horizontal.8534fddd.svg";